'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import replacePlaceholders from 'labels/lib/replacePlaceholders'

import type { ActivePurchaseType } from '../types/activePurchases.types'
import { OrderStatus, StatusLines } from '../types/purchases.types'

export function useStatus() {
	const { t } = useLabels()

	return ({
		activePurchase,
		status,
	}: {
		activePurchase: ActivePurchaseType
		status: string | undefined
	}) => {
		const lastOrder = activePurchase.orders[0]
		const outOfStock = lastOrder.lines.find(
			(order) => order.status === StatusLines.outOfStock
		)

		if (!status && outOfStock) {
			return replacePlaceholders(
				t('profile.lastPurchase.preparation.partialStock.alert'),
				{
					1: activePurchase.purchaseId,
				}
			)
		} else if (status) {
			return lastOrder.status === OrderStatus.annulled
				? replacePlaceholders(t(status), {
						1: activePurchase.purchaseId,
					})
				: t(status)
		} else {
			return undefined
		}
	}
}
